module.exports = __webpack_public_path__ + "img/coinbankC31.0dd86ba0.jpg";